module.exports = __webpack_public_path__ + "img/shopbg.72d57395.png";